import React from 'react';
export function EmailSignature() {
  return <div className="min-h-screen bg-slate-100 py-16 px-4 flex flex-col items-center" data-id="element-330">
      <div className="text-center mb-8" data-id="element-331">
        <h1 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-332">
          Email Signature
        </h1>
        <p className="text-sm text-slate-500" data-id="element-333">
          Copy the signature below for your email client
        </p>
      </div>

      {/* Signature Preview */}
      <div className="bg-white rounded-2xl shadow-md border border-slate-200 p-10 max-w-2xl w-full" data-id="element-334">
        <table cellPadding={0} cellSpacing={0} style={{
        fontFamily: 'Arial, Helvetica, sans-serif',
        color: '#1e293b'
      }} data-id="element-335">
          <tbody data-id="element-336">
            <tr data-id="element-337">
              <td style={{
              paddingRight: 20,
              verticalAlign: 'top'
            }} data-id="element-338">
                {/* Logo */}
                <div style={{
                display: 'flex',
                alignItems: 'center',
                whiteSpace: 'nowrap',
                paddingBottom: 12
              }} data-id="element-339">
                  <span style={{
                  fontSize: 22,
                  fontWeight: 700,
                  color: '#1e293b',
                  letterSpacing: '-0.025em',
                  lineHeight: 1
                }} data-id="element-340">
                    swedenmark
                  </span>
                  <span style={{
                  display: 'inline-block',
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  background: 'linear-gradient(to right, #3b82f6, #a855f7)',
                  margin: '0 3px',
                  transform: 'translateY(2px)'
                }} data-id="element-341"></span>
                  <span style={{
                  fontSize: 22,
                  fontWeight: 700,
                  background: 'linear-gradient(to right, #3b82f6, #a855f7)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  lineHeight: 1
                }} data-id="element-342">
                    ai
                  </span>
                </div>

                {/* Divider */}
                <div style={{
                width: '100%',
                height: 2,
                background: 'linear-gradient(to right, #3b82f6, #a855f7)',
                borderRadius: 2,
                marginBottom: 14
              }} data-id="element-343"></div>

                {/* Name & Title */}
                <div style={{
                marginBottom: 4
              }} data-id="element-344">
                  <span style={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: '#0f172a'
                }} data-id="element-345">
                    Daniel Sorensen
                  </span>
                </div>
                <div style={{
                marginBottom: 12
              }} data-id="element-346">
                  <span style={{
                  fontSize: 13,
                  color: '#64748b',
                  fontWeight: 500
                }} data-id="element-347">
                    Founder & AI Growth Advisor
                  </span>
                </div>

                {/* Company */}
                <div style={{
                marginBottom: 14
              }} data-id="element-348">
                  <span style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#94a3b8',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }} data-id="element-349">
                    AI Automation & Growth Consulting
                  </span>
                </div>

                {/* Contact Links */}
                <div style={{
                display: 'flex',
                gap: 16,
                alignItems: 'center',
                fontSize: 13
              }} data-id="element-350">
                  <a href="https://swedenmark.ai" style={{
                  color: '#475569',
                  textDecoration: 'none',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4
                }} data-id="element-351">
                    🌐 swedenmark.ai
                  </a>
                  <span style={{
                  color: '#cbd5e1'
                }} data-id="element-352">
                    ·
                  </span>
                  <a href="mailto:daniel@swedenmark.ai" style={{
                  color: '#475569',
                  textDecoration: 'none',
                  fontWeight: 500,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4
                }} data-id="element-353">
                    ✉️ daniel@swedenmark.ai
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Raw HTML Version for copying */}
      <div className="mt-10 max-w-2xl w-full" data-id="element-354">
        <h2 className="text-sm font-semibold text-slate-700 mb-3" data-id="element-355">
          Raw HTML (for email clients)
        </h2>
        <div className="bg-slate-900 rounded-xl p-6 overflow-x-auto" data-id="element-356">
          <pre className="text-xs text-slate-300 whitespace-pre-wrap break-all leading-relaxed" data-id="element-357">
            {`<table cellpadding="0" cellspacing="0" style="font-family: Arial, Helvetica, sans-serif; color: #1e293b;">
  <tr>
    <td style="padding-right: 20px; vertical-align: top;">
      <!-- Logo -->
      <div style="display: flex; align-items: center; white-space: nowrap; padding-bottom: 12px;">
        <span style="font-size: 22px; font-weight: 700; color: #1e293b; letter-spacing: -0.025em; line-height: 1;">swedenmark</span>
        <span style="display: inline-block; width: 6px; height: 6px; border-radius: 50%; background: linear-gradient(to right, #3b82f6, #a855f7); margin: 0 3px; transform: translateY(2px);"></span>
        <span style="font-size: 22px; font-weight: 700; background: linear-gradient(to right, #3b82f6, #a855f7); -webkit-background-clip: text; -webkit-text-fill-color: transparent; line-height: 1;">ai</span>
      </div>
      <!-- Divider -->
      <div style="width: 100%; height: 2px; background: linear-gradient(to right, #3b82f6, #a855f7); border-radius: 2px; margin-bottom: 14px;"></div>
      <!-- Name -->
      <div style="margin-bottom: 4px;">
        <span style="font-size: 16px; font-weight: 700; color: #0f172a;">Daniel Sorensen</span>
      </div>
      <div style="margin-bottom: 12px;">
        <span style="font-size: 13px; color: #64748b; font-weight: 500;">Founder & AI Growth Advisor</span>
      </div>
      <!-- Company -->
      <div style="margin-bottom: 14px;">
        <span style="font-size: 12px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.05em;">AI Automation & Growth Consulting</span>
      </div>
      <!-- Links -->
      <div style="display: flex; gap: 16px; align-items: center; font-size: 13px;">
        <a href="https://swedenmark.ai" style="color: #475569; text-decoration: none; font-weight: 500;">🌐 swedenmark.ai</a>
        <span style="color: #cbd5e1;">·</span>
        <a href="mailto:daniel@swedenmark.ai" style="color: #475569; text-decoration: none; font-weight: 500;">✉️ daniel@swedenmark.ai</a>
      </div>
    </td>
  </tr>
</table>`}
          </pre>
        </div>
      </div>

      {/* Plain Text Signature */}
      <div className="mt-16 max-w-2xl w-full" data-id="element-358">
        <div className="text-center mb-8" data-id="element-359">
          <h2 className="text-xl font-bold text-slate-900 mb-2" data-id="element-360">
            Plain Text Version
          </h2>
          <p className="text-sm text-slate-500" data-id="element-361">
            For email clients that don't support HTML signatures
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-md border border-slate-200 p-10" data-id="element-362">
          <pre className="text-sm text-slate-700 font-mono leading-relaxed whitespace-pre-wrap" data-id="element-363">{`—
Daniel Sorensen
Founder & AI Growth Advisor | Swedenmark AI
AI Automation & Growth Consulting

🌐 swedenmark.ai · ✉️ daniel@swedenmark.ai`}</pre>
        </div>

        <div className="mt-6" data-id="element-364">
          <h3 className="text-sm font-semibold text-slate-700 mb-3" data-id="element-365">
            Copy-ready text
          </h3>
          <div className="bg-slate-900 rounded-xl p-6" data-id="element-366">
            <pre className="text-xs text-slate-300 whitespace-pre-wrap leading-relaxed" data-id="element-367">{`—
Daniel Sorensen
Founder & AI Growth Advisor | Swedenmark AI
AI Automation & Growth Consulting

🌐 swedenmark.ai · ✉️ daniel@swedenmark.ai`}</pre>
          </div>
        </div>
      </div>
    </div>;
}